import { ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, inject, DestroyRef } from '@angular/core';
import { FADE_IN_OUT } from '../../shared/animation/fade-in-out-animation';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DashboardFilterService } from './dashboard-filter.service';
import * as _ from 'lodash-es';
import { filter, values } from 'lodash-es';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../shared/_services/gtw-snackbar.service';
import { Observable, Subscription, of } from 'rxjs';
import { SummaryDiagnosticService } from '../summary-diagnostic/summary-diagnostic.service';
import { GlobalService } from '../../global/services/global.service';
import { WorkspaceService } from '../../workspace/workspace.service';
import { AppService } from '../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  hydratedGlobalParams,
} from '../../shared/workspace-element-context';
import {
  getAppkitDropdownSelection,
  mapToAppkitDropdownItems,
  setDropdownAriaLabel
} from '../../shared/utils/appkit-dropdown.util';

@Component({
    selector: 'gtw-dashboard-filter',
    templateUrl: './dashboard.filter.component.html',
    styleUrls: ['./dashboard.filter.component.scss'],
    animations: [FADE_IN_OUT],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DashboardFilterComponent implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);

  private readonly subs = new Subscription();

  isPanelVisible: boolean = false;
  @Output('close-dashboard-filter') closeFilterPanel = new EventEmitter<any>();
  filterGroupKey: number = 701;
  screenKey: number = 0;
  clientKey: number = 0;

  baseURLs: any = {};

  tax_year: any = [{ data: [] }];

  globalParams: any = {};

  filtersData:any = {};
  //loading:boolean = true;
  count: number = 0;
  /** Full filter row from API (filter_key, isLoaded, data, …) — keep for service/cache compatibility */
  taxYearFilterMeta: any = null;
  scenarioFilterMeta: any = null;
  filingGroupFilterMeta: any = null;
  systemFilterMeta: any = null;

  scenarioList: any[] = [];
  filingGroupList: any[] = [];
  systemList: any[] = [];
  taxYearList: any[] = [];
  meList: any = [{ data: [], loading: false }];
  durationInSeconds = 5;
  menuObj1: any = [];
  GENERAL_CONFIG: any = {};
  	childMenuObj : any = []; 
	totalSelected = 0;
	selected : any = [];
	selectedArray : any  = [];
	showMenu = false;
	showRightMenu = false;
  	showBusinessMenu = false;
	showNotificationsPanel = false;
	showSubBusinessMenu = false;
	subBusinessMeData : any = [];
	tempTotalMeSelected = 0;
	singleMeGrpCount = 0;
	totalMeSelected = 0;
	businessfilters :any = [];
	businessMeData : any = [];
    datafiltersLoading:boolean = false;
	businesFilterLoading:boolean = false;
  	filterParams:any = {};  
  @Output() filterSelectedEmitter = new EventEmitter<any>();
  @Output() loadDataTableEmitter = new EventEmitter<any>();
  
  activeScreenFilter:any = {}
	

  // Pre-migration the component received `tax-years` as a CE attribute via
  // `@Input('tax-years') set _tax_years(...) { this.init(); }` which kicked off
  // the whole filter-loading flow exactly once per CE mount. After migration
  // the attribute is gone (data comes from WorkspaceService/GlobalService),
  // and no replacement trigger was added — so `init()` ran only when the user
  // clicked the Filter icon and `notifyObservable$` fired. This flag drives
  // `tryAutoInit()` to fire the original one-shot init as soon as workspace
  // context produces a usable `screenKey` + `tax_year` + `baseURLs.api`.
  private isInitialized = false;

  constructor(
    public filterService: DashboardFilterService,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    public changeDetection: ChangeDetectorRef,
    public summaryDiagService: SummaryDiagnosticService,
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService
  ) {
    if (!this.filterService.filtersLoaded) {
      this.subs.add(
        this.filterService.dataFiltersLoaded.subscribe((data: any) => {
        let loadApiLength = _.filter(this.filtersData,{'data_type':'load'}).length;
		
		  this.filtersData = data.screenFilters.filters
          this.count++;
          if(this.count == loadApiLength && loadApiLength>0){
           // this.loading = false;
            this.filterService.filtersLoaded = true;
            console.log('this filters final', this.filterService.screenFilters);
            this.processFilters({isAllLoaded:true});
          } else if (data.isOnlyFilterLoaded) {
            this.processFilters({ isAllLoaded: false });
          }
          this.changeDetection.markForCheck();
        })
      );
    }
  }
   processFilters(loaded:any){
	console.log('Process filter',this.filterService.screenFilters);
	console.log('Summary diag service',this.summaryDiagService.drillDown);

	let screenObj:any ={};
		screenObj = _.find(this.filterService.screenFilters,{screen_key:this.screenKey});

		_.each(this.filterService.screenFilters,(screenFilterObj)=>{
			if(screenFilterObj.screen_key == this.screenKey){
				_.each(screenFilterObj.filters,(filter) => {

					if(filter.param_name == 'tax_year'){
						this.taxYearList[0] = filter;
					}
					if(filter.param_name == 'scenario'){
						this.scenarioList[0]= filter;
					}else if(filter.param_name == 'filing_key'){
						this.filingGroupList[0]= filter;

					}else if(filter.param_name == 'system'){ 
					this.systemList[0] = filter;
		
					}else if(filter.param_name == 'parent_me_string'){
						if((screenFilterObj.selectedBusiness!= undefined && screenFilterObj.selectedBusiness.length>0) ){	
							this.selectedArray = screenFilterObj.selectedBusiness;
							this.businessfilters.selected =  this.selectedArray;
						}
						this.childMenuObj = [];
						this.menuObj1 = filter;
						if(this.selectedArray.length == 0){
							let firstLoad = 0;
							this.selectAll(firstLoad);
						}
					//	this.selectAll(); need to look;
					
					}
				});
				this.activeScreenFilter = screenFilterObj;
				this.datafiltersLoading= screenFilterObj.datafiltersLoading;
			}
			
		});
		if(loaded.isAllLoaded || loaded.isLoaded){
			this.activeScreenFilter =	_.find(this.filterService.screenFilters,(ii)=>{
				if(ii.screen_key == this.screenKey){
					ii.datafiltersLoading = false;
					this.datafiltersLoading = ii.datafiltersLoading;

				}
			})
			if(this.summaryDiagService.drillDown.isDrillDown){
				this.summaryDiagService.drillDown.isDrillDown = false;
				this.filerSave(false)
			}
		}
		
        console.log('scenario filter',this.scenarioList);
        console.log('filingGroupList filter',this.filingGroupList);
        console.log('systemList filter',this.systemList);
		console.log('menuObj1',this.menuObj1?.data);

		console.log('this.activeScreenFilterthis.activeScreenFilter',this.activeScreenFilter)
   	}
  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.tryAutoInit();
    this.subs.add(
      this.gtwWorkspace.setTabActive.subscribe(() => {
        this.applyWorkspaceContext();
        this.tryAutoInit();
        this.changeDetection.markForCheck();
      })
    );
    this.subs.add(
      this.gtwGlobal.globalParamsChanged$.subscribe(() => {
        this.applyWorkspaceContext();
        this.tryAutoInit();
        this.changeDetection.markForCheck();
      })
    );
    console.log('I am data filters');
    this.subs.add(
      this.filterService.notifyObservable$.subscribe((res) => {
        if (!res?.isEnabled) {
          return;
        }
        const incoming = res.screen_key != null && res.screen_key !== '' ? Number(res.screen_key) : 0;
        if (incoming && this.screenKey === 0) {
          this.screenKey = incoming;
          this.globalParams = { ...this.globalParams, screen_key: this.screenKey };
        }
        if (incoming === this.screenKey) {
          console.log('this is from data filters sub');
          this.filterService.notifyOther({ screen_key: this.screenKey, isEnabled: false });
          this.init();
          // Once the user has manually opened the panel and triggered init via
          // notify, the auto path is no longer needed (init() is idempotent —
          // cache-driven on subsequent calls — but we avoid redundant work).
          this.isInitialized = true;
        }
        this.changeDetection.markForCheck();
      })
    );
  }

  /**
   * One-shot equivalent of the removed `@Input('tax-years') set _tax_years()`
   * that used to call `init()` on the pre-migration custom element. Fires
   * `init()` exactly once per component instance as soon as the workspace
   * context provides everything `init()` (and downstream API calls) need.
   *
   * Guards:
   * - `isInitialized` ⇒ never fires twice for the same instance.
   * - `screenKey > 0` ⇒ without it the filter-by-screen logic in
   *   `processFilters` / `getCurrentFilters` cannot match anything.
   * - `baseURLs.api` truthy ⇒ HTTP calls inside `getCurrentFilters` would
   *   otherwise hit `undefined/getFilters` and silently fail.
   * - `tax_year` has at least one item with a real `label`/`value` (not the
   *   placeholder `[{data: []}]`) ⇒ `getCurrentFilters` iterates this list
   *   to build the initial tax-year selection.
   */
  private tryAutoInit(): void {
    if (this.isInitialized) {
      return;
    }
    if (!this.screenKey || this.screenKey === 0) {
      return;
    }
    if (!this.baseURLs?.api) {
      return;
    }
    if (!Array.isArray(this.tax_year) || this.tax_year.length === 0) {
      return;
    }
    const first = this.tax_year[0];
    const hasRealTaxYear =
      first && (first.label !== undefined || first.value !== undefined || first.text !== undefined);
    if (!hasRealTaxYear) {
      return;
    }
    this.isInitialized = true;
    this.init();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    header.globalParams = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace) || header.globalParams || {};
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    const gp = header.globalParams || {};
    const sk = activeScreen.screen_key ?? gp.screen_key;
    this.screenKey = sk !== undefined && sk !== null && sk !== '' ? Number(sk) : this.screenKey;
    const fg = activeScreen.filter_group_key ?? activeScreen.filterGroupKey;
    this.filterGroupKey = fg !== undefined && fg !== null && fg !== '' ? Number(fg) || 701 : 701;
    this.clientKey = Number(gp.client_key) || Number(this.gtwApp.USER_SETTINGS?.client_key) || 0;
    this.globalParams = { ...gp, screen_key: this.screenKey || gp.screen_key };
    this.syncTaxYearListFromWorkspace();
    this.changeDetection.markForCheck();
  }

  private syncTaxYearListFromWorkspace(): void {
    const values = this.gtwGlobal?.global?.inputs?.tax_year?.values;
    if (Array.isArray(values) && values.length) {
      this.tax_year = values.map((x: any) => ({
        label: x.label ?? x.text ?? String(x.value ?? x.VALUE ?? ''),
        value: x.value ?? x.VALUE,
      }));
      return;
    }
    const ty = this.globalParams?.tax_year ?? this.gtwApp?.USER_SETTINGS?.tax_year;
    if (ty !== undefined && ty !== null && ty !== '') {
      const s = String(ty);
      this.tax_year = [{ label: s, value: s }];
    } else {
      this.tax_year = [{ data: [] }];
    }
  }

	
  init() {
    this.applyWorkspaceContext();
	console.log('from detail',this.screenKey);
	console.log('sumission droll',this.summaryDiagService.drillDown);
	/* if(_.isEmpty(this.globalParams)){
		this.globalParams = {
			"activity_key" : "7687",
			"is_locked" : "N",
			"issue_id" : "",
			"issue_id_for_tx_save" : "",
			"issue_short_desc" : "",
			"jcd_key" : "250",
			"jcd_ta_key" : "5542",
			"scenario" : "40",
			"screen_key" : "11461" ,
			"screen_type" : "custom-tab",
			"tax_year" : "2020"
			}
	} */
	let screenFilterCacheObj:any = {};
	screenFilterCacheObj = _.find(this.filterService.screenFilters,(i)=>{
		return i.screen_key == this.screenKey 
	});
	if(this.summaryDiagService.drillDown.isDrillDown){
		let currentScreenFilters:any;
		let drillDownedScreenFilters:any;
		let selectedSummaryBusiness:any;

		_.each(this.filterService.screenFilters,(i)=>{
			if(i.screen_key == this.summaryDiagService.drillDown.screen_key){
				drillDownedScreenFilters = _.cloneDeep(i.filters);
				selectedSummaryBusiness = _.cloneDeep(i.selectedBusiness);
			}else{
				currentScreenFilters = _.cloneDeep(i.filters);
			}
		});
		let getCurrScreenfilterParams = this.filterService.getFilterParams(this.screenKey);
		let getSummaryFilterParams = this.filterService.getFilterParams(11461);
		if(_.isEqual(drillDownedScreenFilters,currentScreenFilters)){ 
			this.summaryDiagService.drillDown.isDrillDown = false;
			this.filerSave(false);
		}
		/* else if(getCurrScreenfilterParams['tax_year']== getSummaryFilterParams['tax_year'] && 
				getCurrScreenfilterParams['scenario']== getSummaryFilterParams['scenario']){ */
		else if(screenFilterCacheObj && screenFilterCacheObj.filters && screenFilterCacheObj.filters.length){
					// _.each(currentScreenFilters,(ii)=>{
					// 	if(ii.ui_type=='df-select' && ii.data_type != 'inherit'){

					// 		_.each(ii.data,(kk)=>{
					// 			if((kk.value || kk.VALUE) == getSummaryFilterParams[ii.param_name]){
					// 				kk['selected'] = true;
					// 			}else{
					// 				if(kk['selected']){
					// 					kk['selected'] = false;
					// 				}
					// 			}
					// 		});
					// 	}else if(ii.param_name == 'parent_me_string'){
					// 		let summayParentMe = _.find(drillDownedScreenFilters,{filter_key:ii.filter_key});
					// 		ii.data = _.cloneDeep(summayParentMe.data);
					// 		_.filter(this.filterService.screenFilters,(jj)=>{
					// 			if(jj.screen_key == this.screenKey){
					// 				jj['selectedBusiness'] = selectedSummaryBusiness;
					// 				this.selectedArray = selectedSummaryBusiness;
					// 			}
					// 		})
					// 	}
					// });
					_.filter(this.filterService.screenFilters,(ll)=>{
						if(ll.screen_key == screenFilterCacheObj.screen_key){
							ll.filters = _.cloneDeep(drillDownedScreenFilters);//_.cloneDeep(currentScreenFilters);
							ll['selectedBusiness'] = selectedSummaryBusiness;
					 		this.selectedArray = selectedSummaryBusiness;
						}
					});
					this.summaryDiagService.drillDown.isDrillDown = false;

					this.filerSave(false);
		}
		/* else if(screenFilterCacheObj && screenFilterCacheObj.filters && screenFilterCacheObj.filters.length){
			//event.selected[0].value
			let tax_year: any = {selected:[]};
			tax_year.selected.push({value:getSummaryFilterParams['tax_year']});
			console.log('drill taxyear',tax_year);
			_.each(currentScreenFilters,(ii)=>{
				if(ii.ui_type=='df-select' && ii.data_type == 'inherit'){
					_.each(ii.data,(kk)=>{
						if((kk.value || kk.VALUE) == getSummaryFilterParams['tax_year']){
							kk['selected'] = true;
						}else{
							if(kk['selected']){
								kk['selected'] = false;
							}
						}
					});
				}
			})
			this.taxYearSelection(tax_year,null,true);
		} */
		else{//initial load
			this.globalParams['tax_year']=this.summaryDiagService.drillDown.selectedFilterParms.tax_year;
			this.globalParams['scenario']=this.summaryDiagService.drillDown.selectedFilterParms.scenario;
			this.globalParams['filing_key']=this.summaryDiagService.drillDown.selectedFilterParms.filing_key;
			console.log('this drilldown globalPrams',this.globalParams);
			this.getCurrentFilters({isFromDrillDown:true})		

		}
	}else{
		if(screenFilterCacheObj != undefined && screenFilterCacheObj.screen_key != undefined){
			if(screenFilterCacheObj['scenario']== undefined ||screenFilterCacheObj['filing_group']== undefined  || 
				screenFilterCacheObj['system']== undefined  || screenFilterCacheObj['taxYearList']== undefined  || screenFilterCacheObj['business']== undefined ){
				this.processFilters({isAllLoaded:false,isLoaded:true,fromCache:true});
			}
	
		}else{
			this.getCurrentFilters({isFromDrillDown:false});
		}
	}
  
   
  }
  getCurrentFilters(fromDrillDown:any){
	if(_.filter(this.filterService.screenFilters,{screen_key:this.screenKey}).length == 0){
		this.filterService.screenFilters.push({screen_key:this.screenKey,datafiltersLoading:true});		
	}
	this.activeScreenFilter = _.find(this.filterService.screenFilters,{screen_key:this.screenKey});
	this.datafiltersLoading = true;
		
	let datas:any = [];
	let tempTaxYearList:any = [];
/* 	if(this.tax_year[0].data.length == 0){
			
			let data = 
				[{text: '2023', value: '2023', scenario: '66', scenario_desc: 'Return As Filed'},  
				{text: '2022', value: '2022', scenario: '52', scenario_desc: 'Return As Filed'},  
				{text: '2021', value: '2021', scenario: '42', scenario_desc: 'Return As Filed'},  
				{text: '2020', value: '2020', scenario: '40', scenario_desc: 'Return As Filed',selected:true},  
				{text: '2019', value: '2019', scenario: '32', scenario_desc: 'Return As Filed'}, 
				{text: '2018', value: '2018', scenario: '28', scenario_desc: 'Return As Filed'}];
				tempTaxYearList = data;
				datas = data;
		}else{ */
			tempTaxYearList = this.tax_year;
			_.each(tempTaxYearList,(v,key) =>{
				let obj: any = {};
				if(v.label == this.globalParams.tax_year){
					obj['selected'] = true;
				}
				obj.text = v.label;
				obj.label = v.label;
				obj.value = v.value;
				datas.push(obj);
			})
	//	}
        this.filterService.getFilters(this.baseURLs.api,this.filterGroupKey,this.clientKey,this.screenKey,fromDrillDown).pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data:any)=>{
            console.log('data filter',data);
			 if(_.filter(this.filterService.screenFilters,(val,key)=>{
				if(val.screen_key == this.screenKey){
					this.filterService.screenFilters[key]['filters'] = data.filterGroup.filters
				}
			})) 
			this.filterService.getFilterData(datas,this.baseURLs.api,data.filterGroup.filters,this.clientKey, this.globalParams,fromDrillDown).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((filters:any) =>{
			console.log('filter completed apis data',filters);  
			})
        });
  }


  close(){
    this.isPanelVisible = false;;
    console.log('closed');
    this.count = 0;
     this.closeFilterPanel.emit(this.isPanelVisible);
  }
  btnClick() {
    console.log('button is clicked')
  }
  getSelected(){
		this.selected  = [];
		let selected = 0;
		let tempSelectedArray :any = [];

		this.menuObj1.data.forEach( (item : any) => {
			if(item.selected ){
				selected++;
				tempSelectedArray.push(item.key);
			}
			if(item.children && item.children.length > 0) {
				item.numSelected = recursiveSelected(item);
			}
		})

		function recursiveSelected(collection : any){
			var selected = 0;
			function recursiveSelectedInner(collection : any) {
				collection.children.forEach( (item : any) => {
					if(item.selected ){
						//this.selected.push(item.key);
						tempSelectedArray.push(item.key);
						selected++;
					}
					if(item.children && item.children.length > 0) {
						recursiveSelectedInner(item);
					}
				});
			}
			recursiveSelectedInner(collection)
			return selected;
		}
		this.selected = tempSelectedArray;
		return selected;
	}

	checkParent(_item : any){
		let allSelected = true;
		if( _item.parent ){
			_item.parent.children.forEach( (item : any) => {
				if(!item.selected ){
					 allSelected = false;
				}
			});
			_item.parent.selected = allSelected;

			if( _item.parent.parent ){
				this.checkParent(_item.parent);
			}
		}
	}
  change() {
    this.createdSelectedArray();
    this.businessfilters.selected = this.selectedArray;

	_.each(this.filterService.screenFilters,(i)=>{
		if(i.screen_key == this.screenKey){
			//i['business'] = this.menuObj1;
			i['selectedBusiness'] = this.selectedArray;
		}
	});
  }
  createdSelectedArray(){
    this.selectedArray = [];
    for (var i = 0; i < this.selected.length; i++) {
      let newObj :any = {}
      newObj.VALUE = this.selected[i];
      newObj.parnet = this.selected[i];
      newObj.level = this.selected[i];
      this.selectedArray.push(newObj);
    }
  }
	selectedMe(event: any, collection: any, isParent : boolean){
		const originEvent = event?.originalEvent ?? event?.originEvent ?? event;
		if (typeof originEvent?.preventDefault === 'function') {
			originEvent.preventDefault();
		}
		this.showSubBusinessMenu = true;

		let selected: boolean;
		if (event == null) {
			collection.selected = !collection.selected;
			selected = collection.selected;
		} else {
			// PrimeNG `<p-checkbox [binary]="true">` updates `[(ngModel)]` *before*
			// firing `(onChange)`, so `collection.selected` already reflects the
			// new value. We still accept the legacy Appkit4 shapes
			// (`checkboxState`, `srcElement.checked`) so the function stays
			// backwards-compatible with anything still calling it directly.
			const isChecked = event?.checkboxState
				?? event?.checked
				?? event?.srcElement?.checked
				?? collection.selected
				?? false;
			collection.selected = isChecked;
			selected = isChecked;
		}

		function setEm(_collection: any){
			if(_collection.children && _collection.children.length > 0){
				_collection.children.forEach( (item : any) => {
					item.selected = selected;
					if(item.children && item.children.length > 0){
						setEm(item);
					}
				});
			};
		}

		setEm(collection);
		this.checkParent(collection);
		this.getSelected();
		this.change();

		if(isParent){
			this.selectParentMe(collection);
		}

		this.changeDetection.markForCheck();
	}
  selectParentMe(item:any){
		this.setTreeAttribute(this.menuObj1.data,'active','children',false);
		item.active = true;
		this.childMenuObj = item.children;
		this.showSubBusinessMenu = true;
	};
  setTreeAttribute(_collection:any,_predicate:any,_children:any,value:any){
		for (var i = 0; i < _collection.length; i++) {
			var  n = _collection[i][_predicate];
			var children = _collection[i][_children];
			if(children && children.length ){
				this.setTreeAttribute(children,_predicate,_children,value );
			}
			_collection[i][_predicate] = value;
		}
	}
	setMeSelection(me : any, value : boolean){
		//this.tempTotalMeSelected = 0;
		me.forEach( (me : any) => {
			this.tempTotalMeSelected++;
			me.selected = value;
			if(me.children){
				//this.totalMeSelected = value ? this.totalMeSelected + me.children.length : this.totalMeSelected - me.children.length;
				this.setMeSelection(me.children, value);
			};
		});
	};

	getAllMeCounts(me : any){
		let meCount = 0;
		//if(me.children){
		//	meCount += me.children.length;
		me.forEach( (me : any) => {
			meCount++;
			if(me.children){
				getMeCounts(me.children);
			}
		});

		function getMeCounts(me: any){
			me.children.forEach( (me : any) => {

				if(me.children){
					meCount += me.children.length;
					getMeCounts(me.children);
				};
			});
		};
		return meCount;
	};

	meSelection(value: boolean){
		this.tempTotalMeSelected = 0;

		this.businessMeData.forEach( (me : any) => {
			//meCount++;
			//if(me.children){
				this.selectedMe(null, me, true);
			//}
		});

		if(value){
			this.totalMeSelected = this.tempTotalMeSelected;
			console.log(this.singleMeGrpCount);
		}else{
			this.totalMeSelected = 0;
		}
	}

	getTotalSelected(){
		this.totalSelected = this.getSelected();
	}

	selectedSubMe(subMe: any){
		console.log(subMe);
	}

	selectedSubChildMe(subChildMe: any){
		console.log(subChildMe);
	}
  unselectAll(){
		this.setTreeAttribute(this.menuObj1.data,'selected','children',false);
		this.getSelected();
		this.change();
		this.changeDetection.markForCheck();
	}
  selectAll(firstLoad:any){
		this.setTreeAttribute(this.menuObj1.data,'selected','children',true);
		this.getSelectedAll();
		this.change();
		if(firstLoad == 0){
			this.filerSave(true);
		}
		this.changeDetection.markForCheck();
	}
  getSelectedAll(){
		this.selected  = [];
		var selected = 0;
		let tempSelectedArray :any = [];

		this.menuObj1.data.forEach( (item : any) => {
			if(item.selected ){
				selected++;
				//this.selected.push(item.key);
				tempSelectedArray.push(item.key);
			}
			if(item.children && item.children.length > 0) {
				item.numSelected = recursiveSelected(item);
			}
		})

		function recursiveSelected(collection:any){
			var selected = 0;
			function recursiveSelectedInner(collection:any) {
				collection.children.forEach( (item : any) => {
					if(item.selected){
						//this.selected.push(item.key);
						tempSelectedArray.push(item.key);
						selected++;
					}
					if(item.children && item.children.length > 0) {
						recursiveSelectedInner(item);
					}
				});
			}
			recursiveSelectedInner(collection)
			return selected;
		}
		this.selected = tempSelectedArray;
		return selected;		
	}
  filerSave(isFromFilter:any){
	console.log('filterParams', this.filterService.getFilterParams(this.screenKey));
	let filterParams =  this.filterService.getFilterParams(this.screenKey)
	  let missingParamLength = 0;
	  _.map(filterParams,(val,key) =>{
		if(val==""|| val==undefined){
			missingParamLength++;
			if(key=="filing_key"){
				this.openSnackBar('Please Select a Filing Group to Proceed','gtw-snackbar--red');
			}
			else if(key=="parent_me_string"){
				this.openSnackBar('Please Select a Business to Proceed','gtw-snackbar--red');
			}
			else{
				this.openSnackBar(key + ' selection missing','gtw-snackbar--red');
			}
			return;
		}
	  })
	  console.log('filterParams', filterParams);
	  filterParams.isFromFilter = isFromFilter;
	  if(missingParamLength == 0){
		if(this.screenKey == 11460){//detailed screen
			this.filterSelectedEmitter.emit(filterParams);
		  }else{//submission 
			this.loadDataTableEmitter.emit(filterParams);
		  }
	  }
	 
  }
  selectedSystem(event: any, obj: any, isSelected: boolean, systemList: any, index: any){
    console.log('event',event);
    console.log('obj', obj);
    const isChecked = event?.checkboxState ?? event?.srcElement?.checked ?? false;
    this.filterParams['system'] = obj.value;
	this.systemList[index].selected = isChecked;
	this.filterService.filterCache['system'] = this.systemFilterMeta;

  }
  taxYearSelection(event:any,filter:any,isFromDrillDown:any){
		const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
		const change = selected[0] ?? null;
		let scenarioFilter:any = [];
		let screenObj: any ;
		screenObj = _.filter(this.filterService.screenFilters,{screen_key:this.screenKey});
		scenarioFilter = _.filter(screenObj[0].filters,{param_name:'scenario'});
		let scenarioFilterIndex:any;
		scenarioFilterIndex = _.findIndex(screenObj[0].filters,{param_name:'scenario'});
		let params: any = {};
		params.tax_year = selected[0].value;
		if(_.isString((this.globalParams))){
			this.globalParams = JSON.parse(this.globalParams)
		}
		params = _.merge({}, this.globalParams, params);
		params.client_key = this.clientKey;
		let filter_key =  _.filter(screenObj[0].filters,{param_name:'tax_year'})[0].filter_key;

		this.filterService.setFilterLoading(this.screenKey)
		this.filterService.getScenarioRefresh(this.baseURLs.api,scenarioFilter[0],params,scenarioFilterIndex,isFromDrillDown).pipe(takeUntilDestroyed(this.destroyRef))
		.subscribe((data:any)=>{
			if(this.summaryDiagService.drillDown.isDrillDown){
				params.scenario = this.summaryDiagService.drillDown.selectedFilterParms['scenario'];
			}else{
				params.scenario = this.scenarioList[0]?.value;
			}
			params.screen_key = this.screenKey;
			this.filterService.changeRefreshFilters(this.baseURLs.api,filter_key,params,true,isFromDrillDown).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data:any)=>{
				console.log('tax refresh comp');
				if(isFromDrillDown){
					this.summaryDiagService.drillDown.isDrillDown = false;
				}

			})
		})		
		console.log('tax event',event);
  	}

  scenarioSelection(event:any){
	const selected = Array.isArray(event?.selected) ? event.selected : (event?.selected ? [event.selected] : []);
	const change = selected[0] ?? null;
	let params: any = {};
	let screenObj: any ;
	screenObj = _.filter(this.filterService.screenFilters,(i)=>{
		if(i.screen_key == this.screenKey){
			i.scenario = this.scenarioFilterMeta ? [this.scenarioFilterMeta] : [];
			return i;
		}
	});
	this.meList[0].loading = false;

		_.filter(this.taxYearList[0].data,(item)=>{
			if(item.selected){
				params['tax_year'] = item.value;
			}
		});
		params.scenario = selected[0].value;
		if(_.isString((this.globalParams))){
			this.globalParams = JSON.parse(this.globalParams)
		}
		params = _.merge({}, this.globalParams, params);
		params.client_key = this.clientKey;
		params.screen_key = this.screenKey;
	/* 	_.each(this.filterService.screenFilters,(ii)=>{
			if(ii.screen_key == params.screen_key){
				ii.businessLoading = true;
				this.meList[0].loading = ii.businessLoading;
			}
		}) */
		this.filterService.setFilterLoading(this.screenKey)


		this.filterService.changeRefreshFilters(this.baseURLs.api, this.scenarioList[0].filter_key,params,true,false).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data:any)=>{

		})
	}

		  openSnackBar(message: string, panelClass: string = '') {
		    this.gtwSnackbar.openSnackBar(message, (panelClass || '') as any, true, this.durationInSeconds);
		  }
		selectAllSystem(){
			if (this.systemFilterMeta) {
				this.systemFilterMeta.loading = true;
			}
			_.each(this.systemList,(function(i){
				i['selected'] = true;
			}));
			if (this.systemFilterMeta) {
				this.systemFilterMeta.loading = false;
			}
		}
		unselectAllSystem(){
			if (this.systemFilterMeta) {
				this.systemFilterMeta.loading = true;
			}
			_.each(this.systemList,(function(i){
				i['selected'] = false;
			}))
			if (this.systemFilterMeta) {
				this.systemFilterMeta.loading = false;
			}

		}

  setAriaLabel(item: any, contextLabel: string = 'Option'): string {
    const label = item?.label || item?.text || '-';
    return `${contextLabel} option ${label}`.trim();
  }

  onDropdownSelectItem(event: any): void {
  }

  // ---------------------------------------------------------------------------
  // PrimeNG bridge helpers
  // ---------------------------------------------------------------------------
  // The legacy template wired Appkit4 `<ap-dropdown>` to filter wrappers
  // (e.g. `taxYearList[0]`), iterating `*ngFor="let item of taxYearList"` which
  // produced one bogus "option" per filter (the wrapper itself) and lost the
  // real `.data[]` items. After switching to `<p-dropdown>` we bind directly
  // to `filter.data[]`, but we still keep `data[i].selected` as the source of
  // truth because `DashboardFilterService.getFilterParams()` reads it when the
  // user clicks Apply. These helpers keep the two in sync.

  /** Returns the currently selected option (by `selected:true`) for a list. */
  getSelectedFilterItem(items: any[] | null | undefined): any {
    if (!items || !Array.isArray(items)) {
      return null;
    }
    return items.find((item: any) => item && item.selected) || null;
  }

  /**
   * Generic PrimeNG `(onChange)` handler. Marks the picked item as selected on
   * the underlying `filter.data` (so `getFilterParams()` will pick it up) and,
   * for the two cascading filters (`tax_year`, `scenario`), forwards the event
   * to the existing refresh pipelines in the shape they expect
   * (`{selected: [item]}` — same as the original Appkit4 dropdown emitted).
   */
  onFilterDropdownChange(event: any, items: any[] | null | undefined, paramName: string): void {
    if (!items || !Array.isArray(items)) {
      return;
    }
    const picked = getAppkitDropdownSelection(event) ?? event?.value ?? null;
    const pickedValue = picked?.value ?? picked?.VALUE ?? null;

    items.forEach((item: any) => {
      const itemValue = item?.value ?? item?.VALUE;
      item.selected = itemValue === pickedValue;
    });

    if (paramName === 'tax_year') {
      this.taxYearSelection({ selected: [picked] }, undefined, false);
    } else if (paramName === 'scenario') {
      this.scenarioSelection({ selected: [picked] });
    }

    this.changeDetection.markForCheck();
  }

  getFilterDropdownItems(items: any[] | null | undefined): any[] {
    return mapToAppkitDropdownItems(items, 'text', 'value');
  }

  setDropdownAriaLabel(item: any, contextLabel: string = 'Option'): string {
    return setDropdownAriaLabel(item, contextLabel);
  }

  onFilterSelectItem(event: any): void {
    getAppkitDropdownSelection(event);
  }
}

